import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = [ "input", "pricingModeInput" ];

  connect() {
    this.boundOnFocus ||= this.onFocus.bind(this);
    this.inputTarget.addEventListener("focus", this.boundOnFocus);
    this.syncPricingMode();
  }

  disconnect() {
    this.inputTarget.removeEventListener("focus", this.boundOnFocus);
  }

  toggle() {
    this.syncPricingMode();
  }

  onFocus() {
    // Delay select() to let iOS complete its keyboard scroll first
    // Immediate select() interrupts iOS's automatic scroll-into-view behavior
    setTimeout(() => {
      this.inputTarget.select();
    }, 300);
  }

  syncPricingMode() {
    if (!this.hasPricingModeInputTarget) return;

    const checkedInput = this.pricingModeInputTargets.find((input) => input.checked);
    if (checkedInput) this.element.dataset.pricingMode = checkedInput.value;
  }
}
